import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { PT_COMPETENCY_ITEMS } from './ptConstants';

const PtCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="PT"
            title="PT CLINICAL COMPETENCY ASSESSMENT"
            items={PT_COMPETENCY_ITEMS}
            totalPages={6}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default PtCompetency;
